// UrlShortenerForm.jsx
import React, { useState } from 'react';
import urlService from '../services/urlService';
import './UrlShortenerForm.css';

const UrlShortenerForm = () => {
  const [longUrl, setLongUrl] = useState('');
  const [shortUrl, setShortUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setCopySuccess(false);
    
    try {
      const result = await urlService.shortenUrl(longUrl);
      setShortUrl(result.shortUrl);
      setLongUrl(''); // Clear input after success
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shortUrl);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  return (
    <div className="url-shortener-container">
      <div className="content-wrapper">
        <div className="form-section">
          <div className="header">
            <div className="logo">
              <i className="fas fa-link"></i>
            </div>
            <h1>URL Shortener</h1>
            <p className="subtitle">Transform your long URLs into memorable short links</p>
          </div>

          <div className="form-container">
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <div className="input-wrapper">
                  <i className="fas fa-globe input-icon"></i>
                  <input
                    type="url"
                    value={longUrl}
                    onChange={(e) => setLongUrl(e.target.value)}
                    placeholder="Paste your long URL here"
                    required
                    className="url-input"
                  />
                </div>
                <button 
                  type="submit" 
                  disabled={isLoading} 
                  className="submit-button"
                >
                  {isLoading ? (
                    <span className="loading-spinner"></span>
                  ) : (
                    <>
                      <i className="fas fa-cut"></i>
                      <span>Shorten URL</span>
                    </>
                  )}
                </button>
              </div>
            </form>

            {error && (
              <div className="error-message">
                <i className="fas fa-exclamation-circle"></i>
                {error}
              </div>
            )}
          </div>
        </div>

        <div className="results-section">
          {shortUrl && (
            <div className="result-container">
              <h2>
                <i className="fas fa-check-circle"></i>
                Your Shortened URL is Ready!
              </h2>
              <div className="shortened-url">
                <div className="url-display-wrapper">
                  <a 
                    href={shortUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="short-url-link"
                  >
                    <input 
                      type="text" 
                      value={shortUrl} 
                      readOnly 
                      className="short-url-display"
                    />
                  </a>
                  <div className="url-badge">New</div>
                </div>
                <button
                  onClick={handleCopy}
                  className={`copy-button ${copySuccess ? 'copied' : ''}`}
                >
                  <i className={`fas ${copySuccess ? 'fa-check' : 'fa-copy'}`}></i>
                  {copySuccess ? 'Copied!' : 'Copy URL'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UrlShortenerForm;
